import { jsx } from "react/jsx-runtime";
import NearMeIcon from "@mui/icons-material/NearMe";
import { validateTidalLicense } from "../../base/index.js";
function NearMe(props) {
  return /* @__PURE__ */ jsx(
    NearMeIcon,
    {
      "data-testid": "NearMe",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "NearMe",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
NearMe.tidalIconMeta = {
  categories: "map,location,time",
  name: "NearMe"
};
validateTidalLicense();
export {
  NearMe
};
//# sourceMappingURL=NearMe.js.map
